import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { PayrollExportId } from 'services/payrollExports/types';
import { makeSelectCreatedBy } from './selectors';

export interface OwnProps {
    id: PayrollExportId;
}

interface ConnectedProps {
    createdBy: string;
}

type Props = OwnProps & ConnectedProps;

export class TimesheetSubmissionsCreatedByComponent extends React.PureComponent<
    Props
> {
    render(): string | null {
        const { createdBy } = this.props;

        if (!createdBy) {
            return null;
        }

        return createdBy;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    createdBy: makeSelectCreatedBy()
});

export default connect(mapStateToProps)(TimesheetSubmissionsCreatedByComponent);
